import { render, staticRenderFns } from "./detail-flight-and-stay.vue?vue&type=template&id=35b754c7"
import script from "./detail-flight-and-stay.vue?vue&type=script&lang=js"
export * from "./detail-flight-and-stay.vue?vue&type=script&lang=js"
import style0 from "./detail-flight-and-stay.vue?vue&type=style&index=0&id=35b754c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports